import useAuth from 'contexts/AuthContext';
interface AccessControlProps {
  allowedPermissions: string[];
  children: JSX.Element;
}

const AccessControl = ({ allowedPermissions, children }: AccessControlProps) => {
  const { user } = useAuth();

  const checkPermissions = userPermissions => {
    if (allowedPermissions.length === 0) {
      return true;
    }

    if (userPermissions === 'all') {
      return true;
    }

    return userPermissions.some(permission => allowedPermissions.includes(permission));
  };

  const userPermissions = user.isAdmin ? 'all' : user.permissions;

  return checkPermissions(userPermissions) ? children : null;
};

export default AccessControl;
